import xhr from 'live/services/xhr'

const BASE_LIVE_DASHBOARDS_URL = '/rest/dashboard'

export function fetchDashboards(): Promise<{ data: { data: LiveDashboard[] } }> {
    return xhr.get(BASE_LIVE_DASHBOARDS_URL)
}

export function getDashboardLinkNavigation(dashboardId: number): Promise<LiveDashboard[]> {
    return xhr
        .get(`/services/plugin-dashboard-link-navigation/linkedDashboards/${dashboardId}`)
        .then((response: { data: LiveDashboard[] }) => response.data)
}

export function updateDashboardLinkNavigation(
    dashboardId: number,
    dashboards: LiveDashboard[]
): Promise<LiveDashboard[]> {
    return (
        dashboardId &&
        xhr.post(`/services/plugin-dashboard-link-navigation/linkedDashboards/${dashboardId}`, dashboards)
    )
}
